import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const RemoteTeacherNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='teacher' />

export default RemoteTeacherNavItem